// extracted by mini-css-extract-plugin
export default {"slide":"aboutSlide_slide__dmZVF","slide__text":"aboutSlide_slide__text__sb4Y2","slide__btn":"aboutSlide_slide__btn__ELIyw","icons":"aboutSlide_icons__oevnm"};